import { render } from "./inverseTable.vue?vue&type=template&id=c57764a2"
import script from "./inverseTable.vue?vue&type=script&lang=js"
export * from "./inverseTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__